import {
  GET_QUOTE_FUNNELS_PRICES,
  GET_QUOTE_FUNNELS_PRICES_SUCCESS,
  GET_QUOTE_FUNNELS_PRICES_ERROR,

} from "./actionTypes"

export const getQuoteFunnelsPrices = payload => {
  return {
    type: GET_QUOTE_FUNNELS_PRICES,
    payload: payload,
  }
}

export const getQuoteFunnelsPricesSuccess = quote_funnels_prices => {
  return {
    type: GET_QUOTE_FUNNELS_PRICES_SUCCESS,
    payload: quote_funnels_prices,
  }
}

export const getQuoteFunnelsPricesError = error => {
  return {
    type: GET_QUOTE_FUNNELS_PRICES_ERROR,
    payload: error,
  }
}
